import { render, staticRenderFns } from "./handlook.vue?vue&type=template&id=02bc56ac"
import script from "./handlook.vue?vue&type=script&lang=js"
export * from "./handlook.vue?vue&type=script&lang=js"
import style0 from "./handlook.vue?vue&type=style&index=0&id=02bc56ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports